import { render, staticRenderFns } from "./SalesProductDetails.vue?vue&type=template&id=58f1d438&scoped=true&"
import script from "./SalesProductDetails.vue?vue&type=script&lang=js&"
export * from "./SalesProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./SalesProductDetails.vue?vue&type=style&index=0&id=58f1d438&lang=scss&scoped=true&"
import style1 from "./SalesProductDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f1d438",
  null
  
)

export default component.exports